import { TGift } from '@app/models/index';
import { OrdersControllerGiftGetByTokenApiResponse } from '../ordersApi/types';

export const toGift = ({
  nominal,
  cardNumber,
  expireDate,
  product,
  giftMessage,
}: OrdersControllerGiftGetByTokenApiResponse): TGift => {
  return {
    nominal,
    cardNumber,
    expireDate,
    product,
    giftMessage,
  };
};
